module.exports = __webpack_public_path__ + "img/yzsfw_bg.5b69dd12.png";